import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import TrainingForm from "./TrainingForm.jsx";
import { loadSingleTrainingById, saveTrainingDB } from "../../actions/trainingActions.js";
import { AppDispatch, RootState } from "../../store/configureStore";
import Training from "../../types/Training";

const EditTraining: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>(); // Typed dispatch for Thunk actions
  const params = useParams(); // React Router params
  const navigate = useNavigate(); // Navigation hook
  const trainingId = Number(params.trainingId); // Extract training ID from params

  const trainingsStore = useSelector((state: RootState) => state.trainingList); // Redux store data

  // Local state for managing the training data
  const [trainingData, setTrainingData] = useState<Training | undefined>(undefined);

  // Find training by ID in store
  const findTrainingInStoreById = useCallback(
    (id: number) => trainingsStore.find((training) => training.id === id),
    [trainingsStore]
  );

  // Load training data for editing
  const getTrainingForEdit = useCallback(() => {
    let trainingFromStore = findTrainingInStoreById(trainingId);

    if (!trainingFromStore) {
      dispatch(loadSingleTrainingById(trainingId)); // Load data from backend if not in store
    } else {
      return { ...trainingFromStore }; // Make a shallow copy
    }
  }, [dispatch, findTrainingInStoreById, trainingId]);

  // Fetch training data
  useEffect(() => {
    const training = getTrainingForEdit();
    if (training) {
      setTrainingData(training); // Update state only when data is available
    }
  }, [getTrainingForEdit]);

  // Custom save handler for editing training
  const handleSave = async (updatedTraining: Training) => {
    console.log("Saving updated training:", updatedTraining);
    await dispatch(saveTrainingDB(updatedTraining)); // Dispatch save action
    navigate("/trainings"); // Navigate back to the training list
  };

  // Render training form or fallback
  return trainingData ? (
    <TrainingForm training={trainingData} onSave={handleSave} />
  ) : (
    <div>Ładowanie danych treningu...</div>
  );
};

export default EditTraining;
